import React from 'react'

import { AlertCircleIcon } from 'lucide-react'

import { Button } from '@/components/atoms/Button/Button.tsx'
import { cn } from '@/lib/utils.ts'

export interface InlineErrorProps extends React.HTMLAttributes<HTMLDivElement> {
  readonly message: string
  readonly retryLabel?: string
  readonly onRetry?: () => void
  readonly layout?: 'centered' | 'inline'
}

export const InlineError = React.forwardRef<HTMLDivElement, InlineErrorProps>(
  ({ message, retryLabel, onRetry, layout = 'inline', className, ...props }, ref) => (
    <div
      ref={ref}
      role="alert"
      className={cn(
        layout === 'centered'
          ? 'flex flex-1 flex-col items-center justify-center gap-4 p-6 text-center'
          : 'flex items-center gap-2 text-sm text-red-700',
        className
      )}
      {...props}>
      {layout === 'centered' && <AlertCircleIcon aria-hidden className="size-8 stroke-[1.5] text-gray-500" />}
      <p className={cn(layout === 'centered' && 'max-w-[320px] text-base leading-snug text-gray-700')}>{message}</p>
      {onRetry && retryLabel && (
        <Button variant="primary" className="h-10 px-5" onClick={onRetry}>
          {retryLabel}
        </Button>
      )}
    </div>
  )
)
